<div class="vb-wrapper">

    <!-- ── ORDER SUMMARY CARD ── -->
    <div class="order-summary-card">
      <div class="summary-row">
        <div class="summary-item">
          <span class="summary-label">Order No</span>
          <span class="summary-value highlight">{{ order?.orderNumber || '--' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Route</span>
          <span class="summary-value">{{ order?.route || '--' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Truck Count</span>
          <span class="summary-value">{{ order?.numberOfVehicles || order?.numberOfVehicle || '--' }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Procurement Price</span>
          <span class="summary-value green">₹{{ (order?.procurementPrice | number:'1.0-0':'en-IN') || (order?.procurementProvidedAmount | number:'1.0-0':'en-IN') || 0  }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Status</span>
          <span class="summary-value">
            <span class="status-chip" [ngClass]="statusClass(order?.status)">
              {{ order?.status || '--' }}
            </span>
          </span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Placement Date</span>
          <span class="summary-value">{{ order?.vehicleRequiredAt | CustomDatePipe: '' }}</span>
        </div>
      </div>
    </div>
  
    <!-- ── VENDOR BIDS LIST ── -->
    <div class="section-title-row">
      <span class="section-title">Vendor Bids</span>
      <span class="bid-count">{{ vendorBids.length }} bids received</span>
    </div>
  
    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i> Loading bids...
    </div>
  
    <!-- Empty -->
    <div *ngIf="!isLoading && vendorBids.length === 0" class="empty-state">
      <i class="pi pi-inbox empty-icon"></i>
      <p>No bids received yet</p>
    </div>
  
    <!-- Bids Table -->
    <div class="bids-table-wrap" *ngIf="!isLoading && vendorBids.length > 0">
      <table class="bids-table">
        <thead>
          <tr>
            <th>#</th>
            <th style="width: 20%;" (click)="sortBids('vendorName')" class="sortable">
              Vendor Name
              <i
                class="pi"
                [ngClass]="{
                  'pi-sort-alt': sortColumn !== 'vendorName',
                  'pi-sort-amount-up-alt': sortColumn === 'vendorName' && sortDirection === 'asc',
                  'pi-sort-amount-down': sortColumn === 'vendorName' && sortDirection === 'desc'
                }">
              </i>
            </th>
            
            <th (click)="sortBids('procurementPrice')" style="width: 10%;" class="sortable">
              Procurement Bid Amount
              <i
                class="pi"
                [ngClass]="{
                  'pi-sort-alt': sortColumn !== 'procurementPrice',
                  'pi-sort-amount-up-alt': sortColumn === 'procurementPrice' && sortDirection === 'asc',
                  'pi-sort-amount-down': sortColumn === 'procurementPrice' && sortDirection === 'desc'
                }">
              </i>
            </th>

            <th (click)="sortBids('bidAmount')" style="width: 10%;" class="sortable">
              Vendor Bid Amount
              <i
                class="pi"
                [ngClass]="{
                  'pi-sort-alt': sortColumn !== 'bidAmount',
                  'pi-sort-amount-up-alt': sortColumn === 'bidAmount' && sortDirection === 'asc',
                  'pi-sort-amount-down': sortColumn === 'bidAmount' && sortDirection === 'desc'
                }">
              </i>
            </th>
            
            <th style="width: 10%;" (click)="sortBids('vehicleProvided')" class="sortable">
              Vehicles Provided
              <i
                class="pi"
                [ngClass]="{
                  'pi-sort-alt': sortColumn !== 'vehicleProvided',
                  'pi-sort-amount-up-alt': sortColumn === 'vehicleProvided' && sortDirection === 'asc',
                  'pi-sort-amount-down': sortColumn === 'vehicleProvided' && sortDirection === 'desc'
                }">
              </i>
            </th>
            
            <th style="width: 15%;" (click)="sortBids('status')" class="sortable">
              Status
              <i
                class="pi"
                [ngClass]="{
                  'pi-sort-alt': sortColumn !== 'status',
                  'pi-sort-amount-up-alt': sortColumn === 'status' && sortDirection === 'asc',
                  'pi-sort-amount-down': sortColumn === 'status' && sortDirection === 'desc'
                }">
              </i>
            </th>
            <th style="width: 30%;">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let bid of vendorBids; let i = index"
            class="bid-row"
            [class.row-accepted]="bid?.status?.includes('Accepted')"
            [class.row-rejected]="bid?.status?.includes('Rejected')"
            (click)="openCompare(bid)">
            <td>{{ i + 1 }}</td>
            <td>
              <div class="vendor-info">
                <span class="vendor-avatar">{{ (bid?.vendorName || 'V')[0] | uppercase }}</span>
                <span class="vendor-name">{{ bid?.vendorName || '--' }}</span>
              </div>
            </td>
            <td>
              <span class="bid-amount">₹{{ (bid?.procurementPrice | number:'1.0-0':'en-IN') || '--'  }}</span>
            </td>
            <td>
              <span class="bid-amount">₹{{ (bid?.bidAmount | number:'1.0-0':'en-IN') || '--'  }}</span>
            </td>
            <td>{{  bid?.numberOfVehicle || bid?.vehicleProvided || '--' }}</td>
            <td>
              <span class="status-chip" [ngClass]="statusClass(bid?.status)">
                {{
                  statusLabel(bid?.status) === 'Pending On Customer'
                    ? 'Pending On ' + (getFirstWord(bid.accountName) || '')
                    : statusLabel(bid?.status) === 'Rejected By Customer'
                      ? 'Rejected By ' + (getFirstWord(bid.accountName) || '')
                      : statusLabel(bid?.status) === 'Accepted By Customer'
                        ? 'Accepted By ' + (getFirstWord(bid.accountName) || '')
                        : statusLabel(bid?.status)
                }}
              </span>
            </td>
            <td class="d-flex align-items-center gap-2">
              <button
                *ngIf="bid?.status !== 'Closed'"
                type="button"
                class="btn-compare mr-10"
                (click)="openCompare(bid); $event.stopPropagation()">
                View Details
              </button>
              <button
                type="button"
                class="btn-compare mr-10"
                (click)="openTranscation(bid); $event.stopPropagation()">
                View Transaction
              </button>
              <button
                type="button"
                class="btn-whatsapp"
                pTooltip="View WhatsApp Notifications"
                tooltipPosition="top"
                (click)="openWhatsappLogs(bid); $event.stopPropagation()">

                <i class="pi pi-whatsapp"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  
  </div>
  
  
  <!-- ═══════════════════════════════════════
       COMPARE POPUP — old vs new amount
  ════════════════════════════════════════ -->
  <p-dialog
    [(visible)]="showCompareDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '30vw' }"
    styleClass="compare-dialog"
    (onHide)="closeCompare()">
  
    <ng-template pTemplate="header">
      <div class="compare-header">
        <span class="compare-tag">🏷️ RATE COMPARISON</span>
        <div class="compare-vendor">{{ selectedBid?.vendorName || 'Vendor' }}</div>
      </div>
    </ng-template>
  
    <div class="compare-body" *ngIf="selectedBid">
  
      <div class="compare-cols">
  
        <!-- Left: Customer — editable when PendingOnCustomer -->
        <div class="compare-col">
            <div class="col-header customer-header">
            <span class="col-icon">🏢</span>
            <div>
                <div class="col-title">Procurement</div>
                <div class="col-badge" *ngIf="selectedBid?.status !== 'PendingOnCustomer'">🔒 read-only</div>
                <div class="col-badge editable-badge" *ngIf="selectedBid?.status === 'PendingOnCustomer'">✏️ editable</div>
            </div>
            </div>
        
            <!-- Read-only when NOT PendingOnCustomer -->
            <ng-container *ngIf="selectedBid?.status !== 'PendingOnCustomer'">
            <div class="compare-field">
                <label>PROCUREMENT PRICE</label>
                <div class="amount-box readonly">
                <span class="currency">₹</span>
                  <span class="amount-val">
                    {{
                      (selectedBid?.status === 'AcceptedByVendor' ||
                      selectedBid?.status === 'AcceptedByCustomer'
                        ? (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount)
                        : selectedBid?.status === 'PendingOnVendor'
                          ? (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount)
                          : 0)
                      | number:'1.0-0':'en-IN'
                    }}
                  </span>
                </div>
            </div>
        
            <div class="compare-field">
                <label>TRUCK COUNT</label>
                <div class="amount-box readonly">
                <span class="amount-val">{{ selectedBid?.numberOfVehicles || selectedBid?.numberOfVehicle || 1 }}</span>
                </div>
            </div>
            </ng-container>
        
            <!-- Editable when PendingOnCustomer -->
            <ng-container *ngIf="selectedBid?.status === 'PendingOnCustomer'" [formGroup]="counterBidForm">
            <div class="compare-field">
                <label>COUNTER BID AMOUNT <span style="color:red">*</span></label>
                <div class="amount-input-box">
                <span class="currency">₹</span>
                <input
                    type="text"
                    appIndianNumberFormat 
                    class="amount-input"
                    placeholder="Enter amount"
                    formControlName="counterBidAmount" />
                </div>
                <small class="err" *ngIf="counterBidForm.get('counterBidAmount')?.touched && counterBidForm.get('counterBidAmount')?.invalid">
                  Amount must be greater than 0
                  </small>
            </div>
        
            <div class="compare-field">
                <label>TRUCK COUNT</label>
                <div class="amount-input-box">
                <input
                    type="number"
                    class="amount-input"
                    readonly
                    placeholder="1"
                    formControlName="counterVehicles" />
                </div>
            </div>
            </ng-container>
        </div>
  
        <!-- Right: Vendor Bid (read-only) -->
        <div class="compare-col">
            <div class="col-header vendor-header">
            <span class="col-icon">🚛</span>
            <div>
                <div class="col-title">Vendor</div>
                <div class="col-badge">🔒 read-only</div>
            </div>
            </div>
        
            <div class="compare-field">
            <label>BID AMOUNT</label>
            <div class="amount-box readonly bid"
                [class.higher]="selectedBid?.bidAmount > (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount)"
                [class.lower]="selectedBid?.bidAmount < (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount)">
                <span class="currency">₹</span>
                <span class="amount-val">{{ selectedBid?.bidAmount || 0 | number }}</span>
                <span class="diff-badge" *ngIf="selectedBid?.bidAmount && (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount)">
                {{ selectedBid.bidAmount > (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount) ? '▲' : '▼' }}
                {{ ((selectedBid.bidAmount - (selectedBid?.procurementPrice || selectedBid?.procurementProvidedAmount)) | number) }}
                </span>
            </div>
            </div>
        
            <div class="compare-field">
            <label>VEHICLES PROVIDED</label>
            <div class="amount-box readonly">
                <span class="amount-val">{{ selectedBid?.vehicleProvided || selectedBid?.numberOfVehicle || 1 }}</span>
            </div>
            </div>
        </div>
  
      </div>
  
      <!-- Status row -->
      <div class="compare-status-row">
        <span class="compare-status-label">Current Status:</span>
        <span class="status-chip" [ngClass]="statusClass(selectedBid?.status)">
          {{
            statusLabel(selectedBid?.status) === 'Pending On Customer'
              ? 'Pending On ' + (getFirstWord(selectedBid.accountName) || '')
              : statusLabel(selectedBid?.status) === 'Rejected By Customer'
                ? 'Rejected By ' + (getFirstWord(selectedBid.accountName) || '')
                : statusLabel(selectedBid?.status) === 'Accepted By Customer'
                  ? 'Accepted By ' + (getFirstWord(selectedBid.accountName) || '')
                  : statusLabel(selectedBid?.status)
          }}
        </span>
      </div>
    </div>
  
    <ng-template pTemplate="footer">
      <div class="compare-footer" *ngIf="selectedBid?.status !== 'AcceptedByCustomer' && selectedBid?.status !== 'RejectedByVendor' && selectedBid?.status !== 'RejectedByCustomer' && selectedBid?.status !== 'Closed' && selectedBid?.status !== 'PendingOnVendor'">
        <button type="button" class="btn btn-reject-action" [disabled]="actionLoading || isCounterBidEntered()" (click)="onAction('RejectedByCustomer')">
          ✕ Reject
        </button>
    
        <!-- Bidding button — only when PendingOnCustomer -->
        <button
          *ngIf="selectedBid?.status === 'PendingOnCustomer'"
          type="button"
          class="btn btn-bidding-action"
          [disabled]="actionLoading || !isCounterBidEntered() || counterBidForm.get('counterVehicles')?.invalid"
          (click)="onCounterBid()">
          🏷️ Bid
        </button>
    
        <button type="button" class="btn btn-accept-action" [disabled]="actionLoading || isCounterBidEntered()" (click)="onAction('AcceptedByCustomer')">
          ✓ Accept
        </button>
      </div>
    </ng-template>
  
  </p-dialog>
<!-- ═══════════════════════════════════════
     ORDER BIDDING HISTORY POPUP
════════════════════════════════════════ -->
<p-dialog
  [(visible)]="showTransactionDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '42vw' }"
  styleClass="history-dialog"
  (onHide)="closeTransactionDialog()">

  <ng-template pTemplate="header">
    <div class="history-header">
      <span class="history-icon">📜</span>
      <span class="history-title">Order Bidding History</span>
      <span class="history-vendor-tag" *ngIf="selectedBidForHistory?.vendorName">
        {{ selectedBidForHistory?.vendorName }}
      </span>
    </div>
  </ng-template>

  <div class="history-body">

    <!-- Loading -->
    <div *ngIf="transactionLoading" class="loading-state">
      <i class="pi pi-spin pi-spinner"></i> Loading history...
    </div>

    <!-- Empty -->
    <div *ngIf="!transactionLoading && historyTransactions.length === 0" class="empty-state">
      <i class="pi pi-history empty-icon"></i>
      <p>No bidding history yet</p>
    </div>

    <!-- History Table -->
    <div class="history-table-wrap" *ngIf="!transactionLoading && historyTransactions.length > 0">
      <table class="history-table">
        <thead>
          <tr class="group-row">
            <th class="col-counter" rowspan="2">Counter</th>
            <th class="group-vendor" colspan="2">
              <span class="group-icon">🚛</span> Vendor
            </th>
            <th class="group-customer" colspan="2">
              <span class="group-icon">🏢</span> Procurement
            </th>
          </tr>
          <tr class="sub-row">
            <th class="col-vendor">No Of Vehicle</th>
            <th class="col-vendor">Price</th>
            <th class="col-customer">No Of Vehicle</th>
            <th class="col-customer">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let txn of historyTransactions; let i = index"
            class="history-row"
            [class.by-vendor]="txn?.biddingBy === 'VENDOR'"
            [class.by-customer]="txn?.biddingBy === 'CUSTOMER'">

            <td class="col-counter">
              <span class="counter-chip">
                Counter {{ txn?.counter ?? (i + 1) }}
                <i class="pi pi-arrow-up-right side-icon vendor-icon" *ngIf="txn?.biddingBy === 'VENDOR'" title="Vendor bid"></i>
                <i class="pi pi-arrow-up-right side-icon customer-icon" *ngIf="txn?.biddingBy === 'CUSTOMER'" title="Customer bid"></i>
              </span>
            </td>

            <td class="col-vendor" [class.active-cell]="txn?.biddingBy === 'VENDOR'">
              {{ txn?.vehicleProvide || '--' }}
            </td>
            <td class="col-vendor price-cell" [class.active-cell]="txn?.biddingBy === 'VENDOR'">
              <span *ngIf="txn?.vendorPrice">₹{{ txn?.vendorPrice | number }}</span>
              <span *ngIf="!txn?.vendorPrice" class="dash">--</span>
            </td>

            <td class="col-customer" [class.active-cell]="txn?.biddingBy === 'CUSTOMER'">
              {{ txn?.numberOfVehicle || '--' }}
            </td>
            <td class="col-customer price-cell" [class.active-cell]="txn?.biddingBy === 'CUSTOMER'">
              <span *ngIf="txn?.procurementPrice">₹{{ txn?.procurementPrice | number }}</span>
              <span *ngIf="!txn?.procurementPrice" class="dash">--</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</p-dialog>

<p-dialog
    [(visible)]="showWhatsappDialog"
    [modal]="true"
    [style]="{width:'45vw'}"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeWhatsappDialog()">

    <ng-template pTemplate="header">
        <div class="d-flex align-items-center" style="padding: 20px;">
            <i class="pi pi-whatsapp mr-2" style="color:#25D366;font-size:22px;margin-right: 10px;"></i>
            <span>WhatsApp Notification History</span>
        </div>
    </ng-template>

    <div *ngIf="whatsappLoading" class="text-center p-4">
        <i class="pi pi-spin pi-spinner"></i>
        Loading...
    </div>

    <div *ngIf="!whatsappLoading && whatsappLogs.length==0" class="text-center p-4">
        No WhatsApp notification found.
    </div>

    <table class="whatsapp-table" *ngIf="!whatsappLoading && whatsappLogs.length">

      <thead>
          <tr>
              <th>#</th>
              <th>Recipient Name</th>
              <th>Mobile Number</th>
              <th>Status</th>
          </tr>
      </thead>
  
      <tbody>
  
          <tr *ngFor="let log of whatsappLogs; let i=index">
  
              <td>{{i+1}}</td>
  
              <td>{{log.recipientName}}</td>
  
              <td>{{log.recipient}}</td>
  
              <td>
                  <span
                      class="whatsapp-status"
                      [ngClass]="log.notificationStatus.toLowerCase()">
                      {{log.notificationStatus}}
                  </span>
              </td>
  
          </tr>
  
      </tbody>
  
  </table>
</p-dialog>